// extracted by mini-css-extract-plugin
export default {"sectionDiv":"HomePage_sectionDiv__3kuyB","blackDiv":"HomePage_blackDiv__hr529","footerDiv":"HomePage_footerDiv__DxxSl"};